module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("navigation", null, {
    "activeTrigger": _vm.activeTrigger
  }), _vm._v(" "), _vm._t("content")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40f63eb5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/Affix.vue
// module id = 155
// module chunks = 1